import { render, staticRenderFns } from "./depositList.vue?vue&type=template&id=c5f2c8f4&scoped=true&"
import script from "./depositList.vue?vue&type=script&lang=js&"
export * from "./depositList.vue?vue&type=script&lang=js&"
import style0 from "./depositList.vue?vue&type=style&index=0&id=c5f2c8f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f2c8f4",
  null
  
)

export default component.exports